import t from 'utils/translationHelper';

const mapVopErrors = (errors: string[]) => {
  const hasIban = errors.some(error => error.toLowerCase().includes('iban'));
  const hasBic = errors.some(error => error.toLowerCase().includes('bic') || error.toLowerCase().includes('swift'));
  
  let errorMessage = '';
  if (hasIban && hasBic) {
    errorMessage = t('iban_and_bic_validation_error');
  } else if (hasIban) {
    errorMessage = t('iban_validation_error');
  } else if (hasBic) {
    errorMessage = t('bic_validation_error');
  } else {
    errorMessage = errors[0] || t('iban_and_bic_validation_error');
  }
  
  return errorMessage;
}

export default mapVopErrors;